import { render, staticRenderFns } from "./GroupCustomer.vue?vue&type=template&id=86fbe6f8&scoped=true&"
import script from "./GroupCustomer.vue?vue&type=script&lang=js&"
export * from "./GroupCustomer.vue?vue&type=script&lang=js&"
import style0 from "./GroupCustomer.vue?vue&type=style&index=0&id=86fbe6f8&lang=scss&scoped=true&"
import style1 from "./GroupCustomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fbe6f8",
  null
  
)

export default component.exports